import { fontCss, mobileFontCss } from 'common/utils/styleUtilsNew'
import { ColorEntityInterface } from 'src/shared/schemas/color.schema'
import { FontEntityInterface } from 'src/shared/schemas/font.schema'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import styled, { css } from 'styled-components'

type FaqItemTitleUiProps = StrictRequired<
  ColorEntityInterface & FontEntityInterface
> & {
  expanded: boolean
}

export const FaqItemTitleUi = styled.div<FaqItemTitleUiProps>`
  ${p =>
    p.expanded &&
    css`
      margin-bottom: 5px;
    `}
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${fontCss}
  cursor: pointer;
  ${p => p.theme.phone} {
    ${mobileFontCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
    `}
`
